import { toLocaleNumber } from "../../number";

/**
 * @function yearColumnsTariff
 * @description Get the columns for the year statement.
 * @param {Function} gettext - The gettext function.
 * @param {String} locale - The locale.
 * @returns {Object[]} - The columns.
 */
export const yearColumnsTariff = (
  gettext: (key: string) => string,
  locale: string,
) => {
  return [
    {
      field: "meter",
      headerName: gettext("Order No"),
      width: 200,
    },
    {
      field: "meterNumber",
      headerName: gettext("Meter No"),
      width: 150,
    },
    {
      field: "customer",
      headerName: gettext("Company"),
      width: 250,
    },
    // {
    //   field: "address",
    //   headerName: gettext("Address"),
    //   width: 300,
    // },
    {
      field: "streetName",
      headerName: gettext("Street"),
      width: 200,
    },
    {
      field: "buildingNumber",
      headerName: gettext("House No."),
      width: 100,
    },
    {
      field: "postcode",
      headerName: gettext("Zip Code"),
      width: 100,
    },
    {
      field: "cityName",
      headerName: gettext("City"),
      width: 150,
    },
    {
      field: "consumerCVR",
      headerName: gettext("Company No."),
      width: 100,
    },
    {
      field: "gridOperatorName",
      headerName: gettext("Grid company"),
      width: 120,
    },
    // {
    //   field: "inkl_moms",
    //   headerName: gettext("Inkl. Moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "moms",
    //   headerName: gettext("Moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "ekskl_moms",
    //   headerName: gettext("Ekskl. moms"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    {
      field: "spotpris",
      headerName: gettext("Spotpris"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    // {
    //   field: "myndighedsbehandling",
    //   headerName: gettext("Authority Processing"),
    //   // flex: 1,
    //   width: 150,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    {
      field: "elagift",
      headerName: gettext("Total Electricity Charge"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "godtgorelsessats",
      headerName: gettext("Compensation"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "minimumsafgift",
      headerName: gettext("Minimum Fee"),
      // flex: 1,
      width: 150,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "tsoSystemAbonnement",
      headerName: gettext("TSO - System Subscription"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "systemtarif",
      headerName: gettext("System Tariff"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "transmissionsNettarif",
      headerName: gettext("Transmission Grid Tariff"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "nettariff",
      headerName: gettext("Net Tariff"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "rabatNettariff",
      headerName: gettext("Discount Net Tariff"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "abonnement",
      headerName: gettext("Subscription"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "rabatAbonnement",
      headerName: gettext("Discount Subscription"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "radighedstarifs",
      headerName: gettext("Availability Rate"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "netFast",
      headerName: gettext("Availability Payment"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "effektbetaling",
      headerName: gettext("Effect Payment"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    {
      field: "consumption",
      headerName: gettext("kWh"),
      // flex: 1,
      width: 100,
      type: "number",
      valueFormatter: (value: string | number) =>
        toLocaleNumber(locale, value, 0),
    },
    // {
    //   field: "sep",
    //   headerName: gettext("Sep"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "oct",
    //   headerName: gettext("Oct"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "nov",
    //   headerName: gettext("Nov"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
    // {
    //   field: "dec",
    //   headerName: gettext("Dec"),
    //   // flex: 1,
    //   width: 100,
    //   type: "number",
    //   valueFormatter: (value) => toLocaleNumber(locale, value, 0),
    // },
  ];
};
